import React from 'react';
import { observer, inject } from 'mobx-react';
import classNames from 'classnames';
import styles from './specialPanel.scss';
import { ISizeType, ISalesArticleVariantSize } from '../../../stores/types';
import { IVariantStore } from '../../../types/index';
import Length from '../../icons/length';
import Diameter from '../../icons/diameter';
import WWSKioskInfo from '../../workwearStoreAvailabilityModal/wwsKioskInfo/wwsKioskInfo';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

export const SpecialPanel = inject('variantStore')(
    observer(({ variantStore }: IVariantStore) => {
        const tabNavigation = TabNavigationHelper.instance;

        const sizeTypeClick = (event: React.MouseEvent<HTMLDivElement>) => {
            const clickedSizeType = event.currentTarget.dataset.sizetype;
            if (clickedSizeType) variantStore?.changeSelectedSizeType(clickedSizeType);
        };

        const sizeClick = (event: React.MouseEvent<HTMLDivElement>) => {
            if (event.currentTarget.dataset.index) {
                const index = parseInt(event.currentTarget.dataset.index);
                const clickedSize = variantStore?.selectedSizeType?.sizes[index].size;
                if (clickedSize) variantStore?.changeSelectedSize(clickedSize);
            }
        };

        return (
            <div className={styles.special_panel}>
                {variantStore?.mainStore.isMobileShop && (
                    <div data-testid='subheader'
                      data-semantic-id='subheader' className={classNames(styles.subheader, styles.subheader_mobile)}>
                        <label>{variantStore.mainStore.localization.generalL10n.textDiameter}</label>
                        <Diameter />
                    </div>
                )}
                <div data-testid='special-size-type' data-semantic-id='special-size-type' className={styles.special_content}>
                    {variantStore?.mainStore.dataStore.variantSelection.availableSizeTypes.map(
                        (sizeType: ISizeType, index) => (
                            <div
                                key={index}
                                className={classNames(styles.special_value, {
                                    ['pdp-selected']:
                                        variantStore?.selectedSizeType?.sizeTypeName === sizeType.sizeTypeName,
                                    [styles.sold_out]: !variantStore.anySizeExistForSizeType(sizeType),
                                    [styles.special_value_kiosk_sold_out]: variantStore.mainStore.showKioskLayout,
                                })}
                                data-sizetype={sizeType.sizeTypeName}
                                data-testid={sizeType.sizeTypeName}
                                data-semantic-id={sizeType.sizeTypeName}
                                onClick={sizeTypeClick}
                                ref={(el)=>tabNavigation.setFocusAtt(el)}
                            >
                                {sizeType.sizeTypeName}
                            </div>
                        )
                    )}
                </div>
                <label className={styles.chosen_special_size_type}>
                    {variantStore?.mainStore.localization.generalL10n.selection}:
                    {' ' + variantStore?.selectedSizeType?.sizeTypeName}
                </label>
                <div data-testid='subheader' data-semantic-id='subheader' className={styles.subheader}>
                    <label>{variantStore?.mainStore.localization.generalL10n.textLength}</label>
                    <Length />
                </div>
                <div data-testid='special-size' data-semantic-id='special-size' className={styles.special_content}>
                    {variantStore?.selectedSizeType?.sizes.map((savSize: ISalesArticleVariantSize, index) => (
                        <div
                            key={index}
                            data-index={index}
                            data-testid={savSize.size.name}
                            data-semantic-id={savSize.size.name}
                            className={classNames(styles.special_value, {
                                ['pdp-selected']: variantStore?.selectedSize?.size.name === savSize.size.name,
                                [styles.sold_out]: !savSize.salesArticleVariantKey,
                                [styles.special_value_kiosk_sold_out]: variantStore.mainStore.showKioskLayout,
                            })}
                            onClick={sizeClick}
                            ref={(el)=>tabNavigation.setFocusAtt(el)}
                        >
                            {savSize.size.name}
                        </div>
                    ))}
                </div>
                <label className={styles.chosen_special_size}>
                    {variantStore?.mainStore.localization.generalL10n.selection}:
                    {' ' + variantStore?.selectedSize?.size.name}
                </label>
                <WWSKioskInfo />
            </div>
        );
    })
);

